<template lang="html">
  <div>
    <!-- <v-flex xs12 v-if="section.textPre" v-html="_templateLiteralString(section.textPre)"></v-flex> -->
    <v-flex
      v-if="section.textPre"
      xs12
      v-html="section.textPre"
    />

    <v-flex xs12>
      <v-layout>
        <v-flex xs12>
          Concessional contributions cap
        </v-flex>
        <v-flex
          shrink
          class="font-weight-bold"
        >
          {{ _$(result.cap) }}
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout>
        <v-flex xs12>
          Your defined benefit contributions
        </v-flex>
        <v-flex
          shrink
          class="font-weight-bold"
        >
          {{ _$(result.dbc) }}
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout>
        <v-flex xs12>
          Remaining concessional cap space
        </v-flex>
        <v-flex
          shrink
          class="font-weight-bold"
        >
          <v-layout
            ma-0
            align-center
          >
            <v-icon
              v-if="overCap"
              size="20"
              left
              color="warning"
            >
              warning
            </v-icon>
            {{ result.cap_space > 0 ? _$(result.cap_space) : _$(0) }}
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      px-0
      py-3
      xs12
    >
      <v-progress-linear
        :value="(result.dbc / result.cap) * 100"
        height="20"
        :color="overCap ? 'warning' : 'success'"
        background-color=""
        class="si-print-background"
      />
    </v-flex>

    <v-flex
      v-if="overCap && section.textPost"
      xs12
    >
      <v-layout
        align-start
        ma-0
      >
        <v-icon
          left
          color="warning"
        >
          warning
        </v-icon>
        <!-- <v-flex pa-0 class="body-2" v-html="_templateLiteralString(section.textPost)"></v-flex> -->
        <v-flex
          pa-0
          class="body-2"
          v-html="section.textPost"
        />
      </v-layout>
    </v-flex>
  </div>
</template>

<script>
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    data: Object,
    section: Object
  },
  data () {
    return {

    }
  },
  computed: {
    report () {
      return this.data.report || {}
    },
    result () {
      return (this.data || {}).result || {}
    },
    overCap () {
      return this.result.dbc > this.result.cap
    }
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>

</style>
